import React from 'react';
import { X as Close } from 'react-feather';
import { Dialog } from '@headlessui/react';

import VisuallyHidden from '../VisuallyHidden';
import styles from './Modal.module.css';
import { AnimatePresence, motion } from 'framer-motion';

function Modal({
    title,
    description,
    isOpen,
    handleDismiss,
    children,
    withDelay = false,
}) {
    return (
        <AnimatePresence mode='wait'>
            {isOpen && (
                <Dialog
                    static
                    as={motion.div}
                    className={styles.wrapper}
                    open={isOpen}
                    onClose={handleDismiss}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        duration: 0.5,
                        delay: withDelay ? 1.4 : 0,
                    }}
                    exit={{
                        opacity: 0,
                        transition: {
                            duration: 0.5,
                            delay: 0,
                        },
                    }}>
                    <div className={styles.backdrop} onClick={handleDismiss} />
                    <Dialog.Panel className={styles.dialog}>
                        <Dialog.Title className={styles.title}>
                            {title}
                            <button
                                className={styles.closeBtn}
                                onClick={handleDismiss}>
                                <Close />
                                <VisuallyHidden>Dismiss modal</VisuallyHidden>
                            </button>
                        </Dialog.Title>
                        {description && (
                            <Dialog.Description>
                                {description}
                            </Dialog.Description>
                        )}
                        <div className={styles.content}>{children}</div>
                    </Dialog.Panel>
                </Dialog>
            )}
        </AnimatePresence>
    );
}

export default Modal;
